import merge from 'lodash.merge';

import { basicInitialState } from '../../_utils/basicInitialState';
import { DEFAULT_LAYER_VALUES } from 'other/map/layerValues';
import { getDefaultLayerValues } from 'other/map/getDefaultLayerValues';
import { SettingsService } from 'services/settings';

import { EColorDescriptor } from 'pages/Map/types/types';
import { EMapArea, EMapLayer, EMapView, ETrackMode, TMapAreas } from 'types';
import { EUpwellingDepth } from 'other/map/types';
import { TMapOptionsState } from './mapOptionsModel';

/**/
const settings = SettingsService.getMapSettings() as TMapOptionsState;
export const initialMapAreas: TMapAreas = {
  base: EMapArea.OSM,
  feature: EMapArea.EEZ_AREAS,
  zones: [],
  top: []
};
export const initialMapAreasWithEnvironment: TMapAreas = {
  base: EMapArea.OSM,
  feature: null,
  zones: [],
  top: [EMapArea.EEZ_LINES] as any
};
export const initialMapAreasWithWeather: TMapAreas = {
  base: null,
  feature: null,
  zones: [],
  top: [EMapArea.EEZ_LINES] as any
};

/**
 *
 */
const defaultLayerValues = {
  ...DEFAULT_LAYER_VALUES,
  [EMapLayer.UPWELLING]: getDefaultLayerValues(
    EMapLayer.UPWELLING,
    EUpwellingDepth.DEPTH_0
  )
};

/**
 *
 */
const mapAreas = (function () {
  if (!settings.mapAreas) return initialMapAreas;

  if (!('zones' in settings.mapAreas)) {
    // @ts-ignore
    settings.mapAreas.zones = [];
  }
  return settings.mapAreas;
})();

/**
 *
 */
export const mapOptionsInitialState: TMapOptionsState = {
  ...basicInitialState,
  center: settings.center || null,
  zoom: settings.zoom || null,

  colorDescriptor: EColorDescriptor.COUNTRIES,
  fishingActivitySpeed: settings.fishingActivitySpeed || [1, 5.5],
  iceLayers: settings.iceLayers || [],
  isPredictionOn: settings.isPredictionOn,
  layer: settings.layer || null,
  layerDateLabel: null,
  layerInfo: {} as any,
  layerValuesMap: merge(
    {},
    defaultLayerValues,
    settings.layerValuesMap || ({} as any)
  ),
  mapAreaChoice: settings.mapAreaChoice || ({} as any),
  mapAreas: mapAreas,
  // tertiary operator is applied for the transitional period.
  // todo: tertiary operator should be removed in May 2024
  primaryView: settings.primaryView || EMapView.ATLANTIC,
  showName: settings.showName === void 0 ? true : settings.showName,
  showSpeed: settings.showSpeed === void 0 ? true : settings.showSpeed,
  trackMode: settings.trackMode
};
